export const optumThemeOverride = {
  theme: {
    colors: {
      primary1: '$core.color.brand.100',
      info1: '$core.color.brand.60',
      infoFooterBackground: '#f4f6fa',
      uhcPrimary1: '#002677',
      pageBodyBgColor: 'white',
      neutralGray: '$core.color.neutral.80',
      neutralGray2: '#F2F2F2',
      neutralGray4: '$core.color.neutral.30',
      neutralGray5: '#6E7072',
      cardBorder: '$core.color.neutral.20',
      neutralGray7: '$core.color.neutral.90',
      lightGray: '#D0D0D0',
      lightBlue: '#D9F6FA',
      bgHeaderColor: '$lightBlue',
      bgSubHeaderColor: '$lightBlue',
      starBorder: '#D2800F',
      snackCardAvatarBackgroundColor: '#EEF8FB',
      bgProviderDetailsColor: '#FBF9F4',
      icColor: '$core.color.brand.60',
      tcolor: '$uhcPrimary1',
      tabsContainerBackgroundColor: '#DAF6FA',
      tabButtonBackgroundColor: '#FFFFFF',
      tabSelectionTextColor: '$uhcPrimary1',
      tabNotSelectedTextColor: '#424242',
      descriptionBlack: '#19191A',
      whereToGetHelpCardBg1: '$lightBlue',
      whereToGetHelpCardBg2: '$lightBlue',
      whereToGetHelpCardBg3: '$lightBlue',
      milesTextColor: '$core.color.brand.60',
      headerCardWrapperBorderColor: '$lightBlue',
      virtualVisitIconColor: '$core.color.brand.60',
      searchBorderColor: '#929496',
      recentVisitCardSliderBg: '$lightBlue',
      memberInitialsBgColor: '#FFFFFF',
      memberInitialsTextColor: '#424242',
      mapViewContainerBgColor: 'white',
      providerDetailsDrawerHeaderBgColor: '#FBF9F4',
      providerDetailsDrawerHeaderLoadingBgColor: '$core.color.aqua.15',
      providerDetailsDrawerHeaderTextColor: '#4B4D4F',
      providerDetailsDrawerHeaderHighlightColor: '$core.color.brand.100',
      providerDetailsDrawerHeaderInNetworkStatusIconColor: '#007000',
      providerDetailsDrawerHeaderInNetworkStatusLabelColor: '#4B4D4F',
      providerDetailsDrawerLocationsDropdownOptionColor: '#323334',
      'core.color.brand.60': '#196ECF',
      searchIconColor: '$core.color.brand.60',
      errorTextColor: '#D14600',
      notificationColor: '$core.color.brand.100',
      notificationInteractiveColor: '$core.color.brand.60',
      refreshIconColor: '$core.color.brand.80',
      subTextcolor: '#002677',
      orText: '#002677',
    },
    fontSizes: {
      xs: '12.64px',
      extraSmall: '12.64px',
      extraSmallText: '12.64px',
      sm: '14.24px',
      small: '14.24px',
      smallText: '14.24px',
      md: '16px',
      medium: '20.25px',
      mediumText: '20.25px',
      lg: '18px',
      large: '25.63px',
      dateInfoText: '16px',
      providerDetailsDrawerBHFooterTimeStampText: 'sm',
      providerDetailsDrawerBHFooterDateText: 'sm',
    },
    lineHeights: {},
    space: {
      wrapperPadding: '24px 0',
      headerWrapperPadding: '24px 0 0 0',
      tabButtonsPadding: '32px 0 0 0',
      recentSearchBottomGap: 0,
      recentActivityTopPadding: '0px',
      popoverContainerTop: '0px',
      lg: '24px',
      md: '16px',
      sm: '8px',
      xs: '4px',
    },
    fontWeights: {
      medium: '500',
      semibold: '600',
      normalFW: 'normal',
      memeberInitialsFW: '700',
      providerDetailsDrawerHeaderInNetworkFW: 'regular',
      providerDetailsDrawerBHFooterDateFW: 'regular',
    },
    borderWidths: {
      recentActivityBorder: '0px',
    },
    sizes: {
      iconBrandSize: '64px',
      dataCardForMapIconSize: '42px',
      dataCardIconSize: 49,
      snackCardIconSize: 72,
      snackCardIconMobileSize: 60,
      detailsIconSize: 84,
      compareAndShareIconSize: 64,
      recentVisitSnackcardIconSize: 56,
      detailsWidgetHeaderIconSize: 84,
      choosePCPLocationIconSize: 42,
      confirmPCPLocationIconSize: 42,
      choosePCPSuccessIconSize: 45,
    },
    fonts: {
      // optum sans font is deprecated in Abyss V2
      // using AbyssEnterpriseSansVF which is the default font set in Abyss V2 Optum theme instead
      primary: 'AbyssEnterpriseSansVF, Arial, sans-serif',
      heading: 'AbyssEnterpriseSansVF, Arial, sans-serif',
    },
    overflow: {
      popoverContentOverflow: 'visible',
    },
    maxHeight: {
      popoverContentHeight: 'unset',
    },
  },
};
